export default "__VITE_PUBLIC_ASSET__3f46827c__"